import { render, staticRenderFns } from "./ArticleReply.vue?vue&type=template&id=a30210ca&scoped=true&"
import script from "./ArticleReply.vue?vue&type=script&lang=js&"
export * from "./ArticleReply.vue?vue&type=script&lang=js&"
import style1 from "./ArticleReply.vue?vue&type=style&index=1&id=a30210ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30210ca",
  null
  
)

export default component.exports